<template>
  <div class="bg-gray-100 p-3 rounded flex flex-col gap-2">
    <h3 class="font-bold capitalize-first">
      {{ views.find((fView) => fView.type === selectedView).label }}
    </h3>
    <div class="flex flex-row flex-wrap gap-2">
      <BaseButton
        v-for="timeline_group in timeline_groups"
        :key="timeline_group.label"
        :title="timeline_group.label"
        :icon="timeline_group.icon"
        size="extra-small"
        color="primary"
        :is-outline="timeline_group.type !== localTimelineGroupBy"
        inverse-icon-order
        @click="localTimelineGroupBy = timeline_group.type"
      />
    </div>
    <h3 class="font-bold capitalize-first">
      {{ $t('button.filter') }}
    </h3>
    <div class="flex flex-row flex-wrap gap-2">
      <BaseButton
        v-for="type_location in types_location"
        :key="type_location.id"
        :title="type_location.name"
        size="extra-small"
        color="primary"
        :is-outline="!localTimelineLocationFilter.includes(type_location.id)"
        @click="localTimelineLocationFilterToggle(type_location.id)"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default defineComponent({
  name: 'TimelineOption',
  components: { BaseButton },
  props: {
    timelineGroupBy: {
      type: String,
      required: true
    },
    timelineLocationFilter: {
      type: Array,
      required: true
    },
    selectedView: {
      type: String,
      required: true
    },
    views: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      timeline_groups: [
        {
          label: this.$t('attributes.site'),
          icon: 'coffin-cross',
          gate: true,
          type: 'site'
        },
        {
          label: this.$t('attributes.location'),
          icon: 'magnifying-glass-location',
          gate: true,
          type: 'location'
        },
        {
          label: this.$t('attributes.users'),
          icon: 'users',
          gate: true,
          type: 'users'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      types_location: 'metadata/getTypesLocationMetadata'
    }),
    localTimelineGroupBy: {
      get() {
        return this.timelineGroupBy
      },
      set(value) {
        this.$emit('update:timelineGroupBy', value)
      }
    },
    localTimelineLocationFilter: {
      get() {
        return this.timelineLocationFilter ?? []
      },
      set(value) {
        this.$emit('update:timelineLocationFilter', value)
      }
    }
  },
  methods: {
    localTimelineLocationFilterToggle(type) {
      this.localTimelineLocationFilter.indexOf(type) !== -1
        ? this.localTimelineLocationFilter.splice(
            this.localTimelineLocationFilter.indexOf(type),
            1
          )
        : this.localTimelineLocationFilter.push(type)
      this.$emit(
        'update:timelineLocationFilter',
        this.localTimelineLocationFilter
      )
    }
  }
})
</script>
